(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["featured-product-ribbon"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.product-ribbon__atc-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.setAttribute('aria-busy', 'true');
        const originalText = btn.textContent;
        btn.textContent = 'Adding…';

        try {
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              sections: ['mini-cart']
            })
          });

          if (response.ok) {
            const cartContent = await response.json();

            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cartContent }
            }));

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                cart: cartContent,
                replacementDelay: 750,
                openMiniCart: window.themeVariables.settings.cartType === 'drawer' && window.themeVariables.settings.openCartDrawerOnAdd
              }
            }));

            btn.textContent = 'Added ✓';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.removeAttribute('aria-busy');
            }, 1800);
          } else {
            const err = await response.json();
            btn.textContent = originalText;
            btn.removeAttribute('aria-busy');

            btn.dispatchEvent(new CustomEvent('cart-notification:show', {
              bubbles: true,
              cancelable: true,
              detail: {
                status: 'error',
                error: err.description || 'Could not add to cart.'
              }
            }));
          }
        } catch (e) {
          console.error('[product-ribbon] ATC fetch failed:', e);
          btn.textContent = originalText;
          btn.removeAttribute('aria-busy');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
